<template>
    <div class="flex">
        <!--
          <hts-form-button @click="btnClickedHandler()">
          {{ params.title }}
          </hts-form-button>
        -->
        <hts-form-button
            v-for="item in params.options"
            :key="item.action"
            @click="btnClickedHandler(item.action)">
            {{ item.name }}
        </hts-form-button>
    </div>
</template>

<script setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const btnClickedHandler = (action) => {
  params.value.clicked(action, params.value.data)
}
</script>
